import AnalyticServices from "@/core/services/analytics.service";

const analyticServices = new AnalyticServices("");

export default analyticServices;
